import { render, staticRenderFns } from "./CustomerButton.vue?vue&type=template&id=2e1f3012"
import script from "./CustomerButton.vue?vue&type=script&lang=js"
export * from "./CustomerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports